import { Col, Form, Modal, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface InviteMemberModalProps {
  visible: boolean;
  sendInvitationToMembers: (value: any) => void;
  onCancel: () => void;
}

function InviteMemberModal({
  visible,
  sendInvitationToMembers,
  onCancel,
}: InviteMemberModalProps) {
  const [form] = Form.useForm();

  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="직원 초대 하기"
        okText="초대 메일 보내기"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              sendInvitationToMembers(values);
              form.resetFields();
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Row justify="center">
            <Col>
              <h3>초대할 직원 이메일 주소를 입력 하세요.</h3>
            </Col>
          </Row>
          <Form
            layout="vertical"
            form={form}
            name="control-hooks"
            initialValues={{}}
          >
            <Form.Item
              name="emailList"
              label="이메일 리스트"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <TextArea
                style={{ width: '100%' }}
                rows={4}
                placeholder="예) abc@higongsa.com, hello@higongsa.com"
              />
            </Form.Item>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default InviteMemberModal;
